import {decode} from "./Base64";
import * as CommonConstants from "../constants/CommonConstants";
import * as meta from "./Metadata";
import * as FieldType from "../constants/FieldType";
import * as NamaURLS from "../constants/NamaURLS";
import {ajaxJSONWithTask, busy, isNullOrUndefined} from "./NamaCommon";
import {calcReferenceEntityType} from "../widgets/ReferenceWidget";
import {createSearchContextInfo} from "../actions/BaseDispatcher";

export class FieldValuesSetter {
    /**
     *
     * @param {string} encodedValues
     * @param {EditPresenter} presenter
     */
    constructor(encodedValues, presenter) {
        let that = this;
        that.presenter = presenter;
        that.values = [];
        that.fieldValues = encodedValues;
        if (encodedValues.startsWith(CommonConstants.BASE64_PREFIX)) {
            that.fieldValues = decode(encodedValues.substring(CommonConstants.BASE64_PREFIX.length));
            console.log(that.fieldValues);
        }
    }

    start() {
        let that = this;
        let fieldValues = that.fieldValues;
        let fieldsStr = fieldValues.split("--");
        for (let fieldStr of fieldsStr) {
            let parts = fieldStr.split(":=");
            let value = {};
            value.id = parts[0];
            if (!value.id)
                continue;
            if (value.id.contains(">"))
                value.id = value.id.replace('>', '#');
            that.values.push(value);
            if (parts.length > 1) {
                if (parts[1].contains(":@")) {
                    let subValue = parts[1].split(":@");
                    value.value = subValue[0];
                    if (subValue.length > 1)
                        value.rowNumber = subValue[1];
                }
                else {
                    value.value = parts[1];
                }
            }
        }
        that.schedule();
    }

    schedule() {
        let that = this;
        let cb = async function () {
            if (busy())
                that.schedule();
            else {
                let value = that.values[0];
                that.values.splice(0, 1);
                await that.prepareAndSetValue(value);
                if (!that.values.length)
                    return;
                that.schedule();
            }
        }
        setTimeout(cb, 100);
    }

    async prepareAndSetValue(value) {
        if (isNullOrUndefined(value))
            return;
        let that = this;
        let presenter = that.presenter;
        let fieldId = value.id;
        let genRefType = undefined;
        let genRefSelector = undefined;
        if (fieldId.contains("#")) {
            let parts = fieldId.split("#");
            fieldId = parts[0];
            if (parts[1] === "entityType" || parts[1] === "type")
                genRefType = parts[1];
            if (parts[1] === "value" || parts[1] === "code")
                genRefSelector = parts[1];
        }
        let fieldValue = value.value;
        let fieldMetadata = meta.findFieldMetadata(fieldId, presenter.metaData);
        if (!fieldMetadata)
            return;
        let fieldType = fieldMetadata.fieldType;
        if (fieldType === FieldType.Boolean)
            fieldValue = fieldValue === "true" ? true : false;
        if (fieldType === FieldType.Genericreference && genRefType) {
            fieldValue = {entityType: fieldValue};
            that.setValueInfield(fieldValue, that, value.rowNumber, fieldId, genRefType);
            return;
        }

        if (fieldType === FieldType.Reference || (fieldType === FieldType.Genericreference && genRefSelector)) {
            let refEntityType = calcReferenceEntityType(that.fetchCurrentRefEntityType(fieldId, value.rowNumber), fieldMetadata);
            if (!fieldValue)
                fieldValue = null;
            else
                fieldValue = await that.searchForReference(fieldId, fieldValue, refEntityType);
        }
        that.setValueInfield(fieldValue, that, value.rowNumber, fieldId, genRefType);
    }

    setValueInfield(fieldValue, that, rowNumber, fieldId, genRefType) {
        let fieldsWithId = that.presenter.getFieldsWithId(fieldId);
        if (fieldsWithId && fieldsWithId.length) {
            fieldsWithId[0].setValue(fieldValue);
            fieldsWithId[0].oldValue = null;
            fieldsWithId[0].onEdit(fieldValue);
        }
        else if (rowNumber) {
            let grids = that.presenter.getColumnGrids(fieldId);
            if (grids && grids.length) {
                if (rowNumber === "@@last")
                    rowNumber = grids[0]._kendoGrid().dataSource.data().length;
                if (rowNumber === "@@end" && !grids[0].isLastLineEmpty())
                    rowNumber = grids[0]._kendoGrid().dataSource.data().length + 1;
                if (rowNumber && rowNumber > 0)
                    rowNumber = rowNumber - 1;
                if (genRefType)
                    fieldId = fieldId + ".entityType";
                let currentRowsCount = grids[0]._kendoGrid().dataSource.data().length;
                if (rowNumber >= currentRowsCount)
                    grids[0].appendEmptyRows(rowNumber + 1 - currentRowsCount, currentRowsCount - 1, true);
                that.setValueInGrid(grids[0], fieldValue, fieldId, rowNumber);
            }
        }
    }

    setValueInGrid(grid, fieldValue, fieldId, rowNumber) {
        setTimeout(() => {
            if (busy())
                this.setValueInGrid(grid, fieldValue, fieldId, rowNumber);
            else {
                let dataItem = grid._kendoGrid().dataSource.data()[rowNumber];
                if (!dataItem) {
                    this.setValueInGrid(grid, fieldValue, fieldId, rowNumber);
                    return;
                }
                let trimmedId = fieldId.substring((grid.id + ".").length);
                grid.onColumnChanged(trimmedId, fieldValue, dataItem.id);
                let rowIndex = grid._getRowIndex(dataItem.id);
                try {
                    grid.settingValueFromNest = true;
                    grid.setValue(fieldValue, fieldId, rowIndex);
                } finally {
                    delete grid.settingValueFromNest;
                }
            }
        }, 2);

    }

    searchForReference(fieldId, refCode, refEntityType) {
        let that = this;
        let reference = null;
        return ajaxJSONWithTask(NamaURLS.FIND_REF_BY_CODE, {
            code: refCode,
            entityType: refEntityType,
            contextInfo: JSON.stringify(createSearchContextInfo(fieldId, -1, that.presenter))
        }, (ref) => {
            reference = ref;
        }).then(() => Promise.resolve(reference));
    }


    fetchCurrentRefEntityType(fieldId, row) {
        let that = this;
        if (!that.presenter)
            return undefined;
        let fieldValue = that.presenter.getFieldValue(fieldId, row);
        if (fieldValue && fieldValue.entityType)
            return fieldValue.entityType;
        return undefined;
    }

}

